import { type UseQueryResult, useQuery } from 'react-query';
import { StatusDropdownAppServicesService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetTransactionIntendedShareRegistrationsOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: number | string;
      systemName: string;
    }>
  | undefined,
  unknown
> => {
  const transactionIntendedShareRegistrationsOptions = useQuery(
    ['getTransactionIntendedShareRegistrationsOptions'],
    async () => {
      return await handleRequest(
        StatusDropdownAppServicesService.getApiAwardApiAppStatusDropdownAppServicesIntendedShareRegistrations()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
            systemName: item.systemName ?? '',
          };
        });
      },
    }
  );

  return transactionIntendedShareRegistrationsOptions;
};

export default useGetTransactionIntendedShareRegistrationsOptions;
